import { IPipelineLevelData } from '@aclass/core/storage/models/pipeline.level';
import { fromJS, List, Map } from 'immutable';

export const PIPELINE_LEVEL_PRESETS_LEVELS: Map<string, List<IPipelineLevelData['id']>> = fromJS({
    ongoing: [1, 2, 3, 4, 5, 6, 7, 8, 9, 11],
    won: [13],
    lost: [14],
    all: [1, 2, 3, 4, 5, 6, 7, 8, 9, 11, 13, 14],
});
